import { useState, useCallback, useRef, useEffect } from 'react';

export function useProductSelection(productId) {
  const [selectedVariantId, setSelectedVariantId] = useState(null);
  const prevVariantIdRef = useRef(null);
  
  const setSelection = useCallback((variantId) => {
    if (prevVariantIdRef.current !== variantId) {
      prevVariantIdRef.current = variantId;
      setSelectedVariantId(variantId);
    }
  }, []);
  
  useEffect(() => {
    prevVariantIdRef.current = null;
    setSelectedVariantId(null);
  }, [productId]);
  
  const result = [selectedVariantId, setSelection];
  result.selectedVariantId = selectedVariantId;
  result.setSelectedVariantId = setSelection;
  return result;
}
